/** Display name → CSS stack for Froala “Font Family” dropdown (inline editor). */
import FroalaEditor from "froala-editor";
import { syncInlineToolbarVisibility } from "./froalaSelectionUtils";
export const DEFAULT_INLINE_EDITOR_FONT_FAMILIES = {
  Arial: "Arial",
  Georgia: "Georgia",
  Tahoma: "Tahoma",
  "Times New Roman": "Times New Roman",
  Verdana: "Verdana",
};

/**
 * Merges user-saved custom fonts (label + internal family name) into Froala’s fontFamily map.
 */
export function mergeCustomFontsIntoFroalaMap(savedCustomFontList = []) {
  const merged = { ...DEFAULT_INLINE_EDITOR_FONT_FAMILIES };
  for (const row of savedCustomFontList) {
    if (row?.label && row?.familyName) {
      merged[row.label] = `'${row.familyName}', sans-serif`;
    }
  }
  return merged;
}

/** CSS font-family stack for RHS font dropdown options (matches Froala map). */
export function getRhsFontOptionCssStack(
  fontItem,
  savedCustomFontList = [],
) {
  const displayName =
    typeof fontItem === "string"
      ? fontItem
      : fontItem?.family ?? fontItem?.fontFamilyItem ?? "";
  if (!displayName) return "inherit";

  const fontMap = mergeCustomFontsIntoFroalaMap(savedCustomFontList);
  return fontMap[displayName] ?? `'${displayName}', sans-serif`;
}

// export const froalaEditor = (function () {
//   return {
//     config: function (options, onSupClick) {
//       return {
//         key: "pe1G2wD1D1A2B1A5B5nDe1YRTYKd1Dd1f1JVVD1VJKKYLMPvC2B1F1G1B4D4E3B1C8E7==",
//         attribution: false,
//         pastePlain: true,
//         toolbarInline: true,

//         keepFormatOnDelete: true,
//         placeholderText: options.placeHolder,
//         pluginsEnabled: [
//           "align",
//           "link",
//           "lists",
//           "fontFamily",
//           "fontSize",
//           "lineHeight",
//           "format",
//           "colors",
//         ],

//         //   toolbarInline: options.shouldHaveToolbar,
//         immediateReactModelUpdate: options.shouldUpdateImmediatly || false,
//         language: "ro",
//         color: options.color,
//         // pastePlain: true,
//         toolbarButtons: [
//           "bold",
//           "italic",
//           "underline",
//           "strikeThrough",
//           "subscript",
//           "superscript",
//           "textColor",
//           "backgroundColor",
//           "fontSize",
//           "fontFamily",
//           "alignLeft",
//           "alignCenter",
//           "alignRight",
//           // "lineHeight",
//           "formatOL",
//           "formatUL",
//           "insertLink",
//           "undo",
//           "redo",
//         ],
//         fontSize: [9, 10, 12, 14, 18, 24, 29, 32, 50],

//         // lineHeights: {
//         //   1: "1",
//         //   1.25: "1.25",
//         //   2: "2",
//         //   3: "3",
//         //   5: "5",
//         // },
//         shortcutsEnabled: [],
//         shortcuts: false,
//         initOnClick: false,
//         height: "100%",
//         events: {
//           initialized: function (e) {
//             var editor = this;
//             // editor.events.focus();
//             if (!options.contentEditable) {
//               editor.edit.off();
//             }
//             //editor.toolbar.show();
//             editor.events.on(
//               "drop",
//               function (e) {
//                 e.preventDefault();
//                 return false;
//               },
//               true
//             );

//             // this.events.on(
//             //   "keydown",
//             //   function (e) {
//             //     if (e.ctrlKey || e.metaKey) {
//             //       if (e.which === 88) {
//             //         e.preventDefault();
//             //         e.stopPropagation();
//             //         e.stopImmediatePropagation();
//             //         return false;
//             //       }
//             //     }
//             //   },
//             //   true
//             // );
//           },
//         },
//       };
//     },
//   };
// })();

FroalaEditor.DefineIconTemplate(
  "font_size_input",
  '<input class="imc-froala-size-input" value="18" inputmode="decimal" aria-label="Font size">',
);

FroalaEditor.DefineIcon("customFontSize", {
  template: "font_size_input",
});

const fontSizeOptions = {
  9: "9",
  10: "10",
  12: "12",
  14: "14",
  18: "18",
  24: "24",
};

const highlightFontSizePreset = (editor, value, dropdown) => {
  dropdown ||= editor.$tb.find(".imc-font-size-dropdown");
  dropdown.addClass("imc-font-size-dropdown");
  dropdown.get(0)?.querySelectorAll(".fr-command").forEach((option) => {
    const active = option.dataset.param1 === String(value);
    option.classList.toggle("fr-active", active);
    option.setAttribute("aria-selected", active);
    option.style.setProperty("background", active ? "#e6e6e6" : "#fff", "important");
  });
};

FroalaEditor.RegisterCommand("customFontSize", {
  title: "Font Size",
  type: "dropdown",
  focus: false,
  undo: true,
  options: fontSizeOptions,
  callback: function (_command, value) {
    this.fontSize.apply(`${value}px`);
    const input = this.$tb.find(".imc-froala-size-input").get(0);
    input.value = input.dataset.appliedSize = value;
  },
  refreshOnShow: function (_button, dropdown) {
    const value = this.$tb.find(".imc-froala-size-input").val();
    highlightFontSizePreset(this, value, dropdown);
  },
});

export const froalaEditor = (function () {
  return {
    config: function (options, onSupClick) {
      return {
        key: "pe1G2wD1D1A2B1A5B5nDe1YRTYKd1Dd1f1JVVD1VJKKYLMPvC2B1F1G1B4D4E3B1C8E7==",
        attribution: false,
        pastePlain: true,
        toolbarInline: true,
        toolbarVisibleWithoutSelection: false,

        keepFormatOnDelete: true,
        placeholderText: options.placeHolder,
        pluginsEnabled: [
          "align",
          "link",
          "lists",
          "fontFamily",
          "fontSize",
          "lineHeight",
          "format",
          "colors",
        ],

        //   toolbarInline: options.shouldHaveToolbar,
        immediateReactModelUpdate: options.shouldUpdateImmediatly || false,
        language: "ro",
        color: options.color,
        // pastePlain: true,
        toolbarButtons: {
          moreText: {
            buttons: [
              "bold",
              "italic",
              "underline",
              "strikeThrough",
              "subscript",
              "superscript",
              "textColor",
              "backgroundColor",
              "customFontSize",
              "fontFamily",
              "insertLink",
              "undo",
              "redo",
            ],
            align: "left",
            margin: 0,
            buttonsVisible: 19,
          },
          moreParagraph: {
            buttons: [
              "alignLeft",
              "alignCenter",
              "alignRight",
              "alignJustify",
              "formatOL",
              "formatUL",
              "paragraphFormat",
              "paragraphStyle",
              "lineHeight",
              "outdent",
              "indent",
              "quote",
            ],
            align: "left",
            buttonsVisible: 0,
          },
        },
        fontSize: [9, 10, 12, 14, 18, 24],
        fontFamily: mergeCustomFontsIntoFroalaMap(options.savedCustomFontList),

        // lineHeights: {
        //   1: "1",
        //   1.25: "1.25",
        //   2: "2",
        //   3: "3",
        //   5: "5",
        // },
        shortcutsEnabled: [],
        shortcuts: false,
        initOnClick: false,
        height: "100%",
        events: {
          initialized: function (e) {
            var editor = this;
            const sizeInput = editor.$tb
              .find(".imc-froala-size-input")
              .get(0);
            sizeInput.dataset.appliedSize = sizeInput.value;
            let editing = false;

            const applyTypedSize = () => {
              const size = Number(sizeInput.value);
              if (!sizeInput.value || size < 1 || size > 200) {
                sizeInput.value = sizeInput.dataset.appliedSize;
                editing = false;
                return;
              }
              sizeInput.value = Math.round(size * 100) / 100;
              sizeInput.dataset.appliedSize = sizeInput.value;
              editing = false;
              try {
                editor.selection.restore();
                editor.fontSize.apply(`${size}px`);
              } catch (_error) {
                sizeInput.value = sizeInput.dataset.appliedSize;
              }
            };

            sizeInput.addEventListener("mousedown", (event) => {
              event.stopPropagation();
              editor.events.disableBlur();
              if (editor.selection.text()) editor.selection.save();
            });
            sizeInput.addEventListener("click", (event) => {
              event.stopPropagation();
              setTimeout(() => {
                editor.events.disableBlur();
                sizeInput.focus();
              });
            });
            sizeInput.addEventListener("blur", () => {
              if (editing) applyTypedSize();
              editor.events.enableBlur();
            });
            sizeInput.addEventListener("input", (event) => {
              event.target.value =
                event.target.value.match(/^\d{0,3}(?:\.\d{0,2})?/)?.[0] || "";
              editing = true;
              highlightFontSizePreset(editor, event.target.value);
            });
            sizeInput.addEventListener("keydown", (event) => {
              if (event.key !== "Enter") return;
              event.preventDefault();
              event.stopPropagation();
              applyTypedSize();
              editor.button.hideActiveDropdowns(editor.$tb);
            });

            const syncSizeInput = () => {
              if (document.activeElement === sizeInput) return;
              const element = editor.selection.element();
              if (!element) return;
              const size = Number.parseFloat(
                editor.win.getComputedStyle(element).fontSize,
              );
              if (Number.isFinite(size)) {
                sizeInput.value = Math.round(size * 100) / 100;
                sizeInput.dataset.appliedSize = sizeInput.value;
              }
            };
            editor.events.on("selection.change", syncSizeInput);
            editor.events.on("toolbar.show", syncSizeInput);
            // editor.events.focus();

            if (!options.contentEditable) {
              editor.edit.off();
            }
            //editor.toolbar.show();
            // Froala command popups attach to document.body; cap list height so long font lists scroll.
            var scrollStyleId = "imc-froala-font-dropdown-scroll";
            var scrollStyleRules =
              ".fr-popup.fr-active .fr-buttons{" +
              "max-height:min(180px,30vh);overflow-y:auto!important;overflow-x:hidden;" +
              "}" +
              ".fr-command.fr-btn+.fr-dropdown-menu{" +
              "max-width:min(250px,70vw)!important;" +
              "}" +
              ".fr-command.fr-btn+.fr-dropdown-menu .fr-dropdown-wrapper," +
              ".fr-command.fr-btn+.fr-dropdown-menu.test-height .fr-dropdown-wrapper{" +
              "max-height:min(180px,30vh)!important;max-width:min(250px,70vw)!important;" +
              "overflow-y:auto!important;overflow-x:hidden;" +
              "}" +
              ".fr-command.fr-btn+.fr-dropdown-menu .fr-dropdown-wrapper .fr-dropdown-content ul.fr-dropdown-list{" +
              "min-width:0!important;max-width:min(250px,70vw)!important;" +
              "}" +
              ".fr-command.fr-btn+.fr-dropdown-menu .fr-dropdown-wrapper .fr-dropdown-content ul.fr-dropdown-list li a{" +
              "display:block!important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" +
              "max-width:min(250px,70vw)!important;padding:0 12px!important;" +
              "}";
            var scrollStyle = document.getElementById(scrollStyleId);
            if (!scrollStyle) {
              scrollStyle = document.createElement("style");
              scrollStyle.id = scrollStyleId;
              document.head.appendChild(scrollStyle);
            }
            scrollStyle.textContent = scrollStyleRules;

            editor.events.on(
              "drop",
              function (e) {
                e.preventDefault();
                return false;
              },
              true,
            );

            editor.events.on("selection.change", function () {
              syncInlineToolbarVisibility(editor);
            });

            editor.events.on("keyup", function () {
              syncInlineToolbarVisibility(editor);
            });
            // this.events.on(
            //   "keydown",
            //   function (e) {
            //     if (e.ctrlKey || e.metaKey) {
            //       if (e.which === 88) {
            //         e.preventDefault();
            //         e.stopPropagation();
            //         e.stopImmediatePropagation();
            //         return false;
            //       }
            //     }
            //   },
            //   true
            // );
          },
        },
      };
    },
  };
})();
